@if (isLoading) {
  <div class="step-loading">
    <mat-spinner style="height: 50px !important"></mat-spinner>
  </div>
}

@if (!isLoading) {
  <div class="filter-box">
    <div class="action-group">
      @if (authService.hasPermission(Permission.PostAssetsPreRelease) || product.releasedInCollection) {
        <mat-checkbox
          (change)="setAll($event.checked)"
          [checked]="allSelected"
          [color]="'primary'"
        >Select all</mat-checkbox>
      }
      @if (authService.hasPermission(Permission.PostAssetsPreRelease)) {
        <button
          mat-stroked-button
          class="download-multiple"
          (click)="downloadMultiple()"
          [disabled]="disableButtonDownload()"
          >
          <mat-icon>file_download</mat-icon>Download{{ "(" + selectedCount + ")" }}
        </button>
      }
      @if (!authService.hasPermission(Permission.PostAssetsPreRelease) && product.releasedInCollection) {
        <button
          mat-stroked-button
          class="download-multiple"
          (click)="downloadMultiple()"
          [disabled]="disableButtonDownload()"
          >
          <mat-icon>file_download</mat-icon>Download Outputs
          {{ "(" + selectedCount + ")" }}
        </button>
      }
    </div>
    <div class="filter-group">
      <app-label-data-product-create-action
        [selectedProducts]="[product]"
      ></app-label-data-product-create-action>
      <span
      [matTooltip]="
        !product.productLabelDataGenerated
          ? 'No Data Generated'
          : 'Download Product Label Data'
      "
        >
        @if (authService.hasPermission(Permission.PostAssetsPreRelease)) {
          <button
            [disabled]="!product.productLabelDataGenerated"
            mat-icon-button
            class="apply-enhancement"
            (click)="downloadProductLabelData()"
            >
            <div
              class="icon-wrapper"
              [ngClass]="{ 'disabled-icon': !product.productLabelDataGenerated }"
              >
              <mat-icon class="icon icon-a">text_snippet</mat-icon>
              <mat-icon class="icon icon-b">download</mat-icon>
            </div>
          </button>
        }
      </span>
      @if (product.externalShopifyId != null && authService.hasPermission(Permission.PostAssetsPreRelease)) {
        <button
          mat-icon-button
          class="apply-enhancement"
          matTooltip="Sync Assets to Shopify"
          (click)="syncProductAssets()"
          >
          <mat-icon>shopify</mat-icon>
        </button>
      }
      <app-create-outputs-icon-action
        [product]="product"
        [selectedPostAssetIds]="getSelectedPostAssetIds()"
      ></app-create-outputs-icon-action>
    </div>
  </div>
}

@if (!isLoading) {
  @for (item of content; track item) {
    <div>
      <mat-expansion-panel expanded="true">
        <mat-expansion-panel-header>
          <mat-panel-title style="justify-content: space-between; align-items: center;">
            <div class="touch">
              <div>
                @if (displaySelectTouch[item.id]) {
                  <mat-checkbox
                    (click)="$event.stopPropagation()"
                    (change)="onTouchAllSelected($event.checked, item)"
                    [checked]="item.selectedTouch"
                    [color]="'primary'"
                  ></mat-checkbox>
                }
              </div>
              <div class="touch-info">
                <div class="touch-title">{{ formatTitle(item) }}</div>
                <div class="touch-description">{{ formatSubtitle(item) }}</div>
              </div>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div
          class="step-list"
          [ngStyle]="{ 'grid-template-columns': 'repeat(' + colPerScreen + ',minmax(0,1fr))' }"
        >
          @for (asset of item.assets; track asset) {
            <app-card-item
              [dataType]="'outputAssets'"
              [data]="asset"
              [editCallback]="editCallback"
              [touchId]="item.id"
              [parentSection]="item"
              [releasedInCollection]="!!product.releasedInCollection"
              (done)="onCardDone()"
              (selectedCheckbox)="onCardSelected($event)"
            ></app-card-item>
          }
        </div>
      </mat-expansion-panel>
    </div>
  }
}
